export default __webpack_public_path__ + "static/media/manage_suppliers.1aac75fa.svg";